export const config = {
  wpAjaxUrl: window.wpAjaxUrl || '/wp-admin/admin-ajax.php'
}